/* Name und E-Mail-Adresse einer Person für Listen (Nutzerverwaltung, Zugangsanfragen).
 *
 * Konten ohne Namen — oder mit der E-Mail-Adresse als Namen — zeigten die Adresse doppelt
 * (als Name und als Adresse darunter). Hier kommt sie genau einmal.
 */

const clean = (v) => String(v ?? '').trim();

/**
 * @param {string} name   Anzeigename (kann leer oder gleich der E-Mail sein)
 * @param {string} email
 * @param {{emptyTitle?: string}} [opts]  emptyTitle: Titel für "kein Name" (z. B. "No name given");
 *   dann steht die Adresse als Zeile darunter. Ohne: die Adresse selbst ist der Titel.
 * @returns {{title: string, subtitle: string|null}}  subtitle null = nichts zweites anzeigen
 */
export function identityLines(name, email, opts = {}) {
  const n = clean(name);
  const e = clean(email);
  if (!n || n.toLowerCase() === e.toLowerCase()) {
    if (!n && opts.emptyTitle) return { title: opts.emptyTitle, subtitle: e || null };
    return { title: e || n, subtitle: null };
  }
  return { title: n, subtitle: e || null };
}
